// extracted by mini-css-extract-plugin
export default {"formContainer":"Pitch_formContainer__6-r+G","darkBackground":"Pitch_darkBackground__cQIyo"};